<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-details-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <div class="center">
        <div fxLayout="row wrap" style="overflow-y: scroll;">

            <div class="about-content p-24" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent">
                        <div class="title">{{ user.firstName }} {{ user.lastName }}</div>
                    </header>

                    <div class="content">
                        <div class="info-line" *ngIf="user.multiSport && this.multiSportUsedToday">
                            <div class="title">{{'Multi Sport'|translate}}</div>
                            <div class="info">
                                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon style="color: #ff9800; margin-right: 12px;">info</mat-icon>
                                        <span style="color: #856404;">
                                            {{'Discount already used today. Next use available tomorrow.'|translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.multiSport && !this.multiSportUsedToday">
                            <div class="title">{{'Multi Sport'|translate}}</div>
                            <div class="info">
                                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                                    <div *ngIf="multiSportError" style="color: red;" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        {{multiSportMessage}}<br/>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Card number'|translate}}</mat-label>
                                            <input matInput formControlName="cardNumber" (input)="verifyCardNumber($event)">
                                            <div style="color: red;" *ngIf="!checkingCardNumber && cardExists">{{'Card already assigned to other customer!'|translate}}</div>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="50">
                                            <mat-label>{{'Voucher'|translate}}</mat-label>
                                            <mat-select formControlName="multiSportVoucherId">
                                                <mat-option [value]="voucher.id" *ngFor="let voucher of vouchers">
                                                    {{voucher.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        <div class="card" *ngFor="let voucher of vouchers" style="max-width: 200px;" (click)="selectMultiSportVoucher(voucher)">

                                            <!-- PREVIEW -->
                                            <div class="card-preview">
                                                <div class="fuse-card variable-width">
                                                    <div class="position-relative">
                                                        <div [ngStyle]="{background: voucher.group?voucher.group.color:'white'}" class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;">
                                                            {{voucher.name}}<br/><br/>
                                                            {{'Service'|translate}}: {{voucher.services[0].service.name}}
                                                        </div>
                                                    </div>

                                                    <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
<!--                                                        <button mat-icon-button aria-label="additional informations" (click)="showAdditionalVoucherInformationsDialog(voucher)">-->
<!--                                                            <mat-icon>info</mat-icon>-->
<!--                                                        </button>-->
                                                        <a mat-icon-button aria-label="add to card">
                                                            <mat-icon>add</mat-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / PREVIEW -->

                                        </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <button mat-raised-button type="submit" color="accent" [disabled]="cardExists || cardNumber.length === 0 || submitted">
                                                {{'Add'|translate}}
                                            </button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.medicover && this.medicoverUsedToday">
                            <div class="title">{{'Medicover'|translate}}</div>
                            <div class="info">
                                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon style="color: #ff9800; margin-right: 12px;">info</mat-icon>
                                        <span style="color: #856404;">
                                            {{'Discount already used today. Next use available tomorrow.'|translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.medicover && !this.medicoverUsedToday">
                            <div class="title">{{'Medicover'|translate}}</div>
                            <div class="info">
                                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                                      fxFlex="1 0 auto" name="medicoverForm" [formGroup]="medicoverForm" (ngSubmit)="onSubmitMedicover()">

                                    <div *ngIf="medicoverError" style="color: red;" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        {{medicoverMessage}}<br/>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Card number'|translate}}</mat-label>
                                            <input matInput formControlName="cardNumber" (input)="verifyCardNumber($event)">
                                            <div style="color: red;" *ngIf="!checkingCardNumber && cardExists">{{'Card already assigned to other customer!'|translate}}</div>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="50">
                                            <mat-label>{{'Voucher'|translate}}</mat-label>
                                            <mat-select formControlName="medicoverVoucherId">
                                                <mat-option [value]="voucher.id" *ngFor="let voucher of medicoverVouchers">
                                                    {{voucher.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        <div class="card" *ngFor="let voucher of medicoverVouchers" style="max-width: 200px;" (click)="selectMedicoverVoucher(voucher)">

                                            <!-- PREVIEW -->
                                            <div class="card-preview">
                                                <div class="fuse-card variable-width">
                                                    <div class="position-relative">
                                                        <div [ngStyle]="{background: voucher.group?voucher.group.color:'white'}" class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;">
                                                            {{voucher.name}}<br/><br/>
                                                            {{'Service'|translate}}: {{voucher.services[0].service.name}}
                                                        </div>
                                                    </div>

                                                    <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
                                                        <!--                                                        <button mat-icon-button aria-label="additional informations" (click)="showAdditionalVoucherInformationsDialog(voucher)">-->
                                                        <!--                                                            <mat-icon>info</mat-icon>-->
                                                        <!--                                                        </button>-->
                                                        <a mat-icon-button aria-label="add to card">
                                                            <mat-icon>add</mat-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / PREVIEW -->

                                        </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <button mat-raised-button type="submit" color="accent" [disabled]="cardExists || cardNumber.length === 0 || submitted">
                                                {{'Add'|translate}}
                                            </button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.pzuSport && this.pzuSportUsedToday">
                            <div class="title">{{'PZU Sport'|translate}}</div>
                            <div class="info">
                                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon style="color: #ff9800; margin-right: 12px;">info</mat-icon>
                                        <span style="color: #856404;">
                                            {{'Discount already used today. Next use available tomorrow.'|translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.pzuSport && !this.pzuSportUsedToday">
                            <div class="title">{{'PZU Sport'|translate}}</div>
                            <div class="info">
                                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                                      fxFlex="1 0 auto" name="pzuSportForm" [formGroup]="pzuSportForm" (ngSubmit)="onSubmitPzuSport()">

                                    <div *ngIf="pzuSportError" style="color: red;" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        {{pzuSportMessage}}<br/>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Card number'|translate}}</mat-label>
                                            <input matInput formControlName="cardNumber" (input)="verifyCardNumber($event)">
                                            <div style="color: red;" *ngIf="!checkingCardNumber && cardExists">{{'Card already assigned to other customer!'|translate}}</div>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="50">
                                            <mat-label>{{'Voucher'|translate}}</mat-label>
                                            <mat-select formControlName="pzuSportVoucherId">
                                                <mat-option [value]="voucher.id" *ngFor="let voucher of pzuSportVouchers">
                                                    {{voucher.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        <div class="card" *ngFor="let voucher of pzuSportVouchers" style="max-width: 200px;" (click)="selectPzuSportVoucher(voucher)">

                                            <!-- PREVIEW -->
                                            <div class="card-preview">
                                                <div class="fuse-card variable-width">
                                                    <div class="position-relative">
                                                        <div [ngStyle]="{background: voucher.group?voucher.group.color:'white'}" class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;">
                                                            {{voucher.name}}<br/><br/>
                                                            {{'Service'|translate}}: {{voucher.services[0].service.name}}
                                                        </div>
                                                    </div>

                                                    <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
                                                        <!--                                                        <button mat-icon-button aria-label="additional informations" (click)="showAdditionalVoucherInformationsDialog(voucher)">-->
                                                        <!--                                                            <mat-icon>info</mat-icon>-->
                                                        <!--                                                        </button>-->
                                                        <a mat-icon-button aria-label="add to card">
                                                            <mat-icon>add</mat-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / PREVIEW -->

                                        </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <button mat-raised-button type="submit" color="accent" [disabled]="cardExists || cardNumber.length === 0 || submitted">
                                                {{'Add'|translate}}
                                            </button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.profit && this.profitUsedToday">
                            <div class="title">{{'ProFit'|translate}}</div>
                            <div class="info">
                                <div class="mat-card mat-elevation-z4 p-24 mr-24" style="background-color: #fff3cd; border-left: 4px solid #ffc107;">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon style="color: #ff9800; margin-right: 12px;">info</mat-icon>
                                        <span style="color: #856404;">
                                            {{'Discount already used today. Next use available tomorrow.'|translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.profit && !this.profitUsedToday">
                            <div class="title">{{'ProFit'|translate}}</div>
                            <div class="info">
                                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                                      fxFlex="1 0 auto" name="profitForm" [formGroup]="profitForm" (ngSubmit)="onSubmitProfit()">

                                    <div *ngIf="profitError" style="color: red;" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        {{profitMessage}}<br/>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                                        <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                                            <mat-label>{{'Card number'|translate}}</mat-label>
                                            <input matInput formControlName="cardNumber" (input)="verifyCardNumber($event)">
                                            <div style="color: red;" *ngIf="!checkingCardNumber && cardExists">{{'Card already assigned to other customer!'|translate}}</div>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex="50">
                                            <mat-label>{{'Voucher'|translate}}</mat-label>
                                            <mat-select formControlName="profitVoucherId">
                                                <mat-option [value]="voucher.id" *ngFor="let voucher of profitVouchers">
                                                    {{voucher.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                                        <div class="card" *ngFor="let voucher of profitVouchers" style="max-width: 200px;" (click)="selectProfitVoucher(voucher)">

                                            <!-- PREVIEW -->
                                            <div class="card-preview">
                                                <div class="fuse-card variable-width">
                                                    <div class="position-relative">
                                                        <div [ngStyle]="{background: voucher.group?voucher.group.color:'white'}" class="p-16" fxLayout="row" fxLayoutAlign="space-between start" style="text-align: center;">
                                                            {{voucher.name}}<br/><br/>
                                                            {{'Service'|translate}}: {{voucher.services[0].service.name}}
                                                        </div>
                                                    </div>

                                                    <div class="px-16 py-4" fxLayout="row" fxLayoutAlign="center center">
                                                        <!--                                                        <button mat-icon-button aria-label="additional informations" (click)="showAdditionalVoucherInformationsDialog(voucher)">-->
                                                        <!--                                                            <mat-icon>info</mat-icon>-->
                                                        <!--                                                        </button>-->
                                                        <a mat-icon-button aria-label="add to card">
                                                            <mat-icon>add</mat-icon>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / PREVIEW -->

                                        </div>
                                    </div>

                                    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                                        <div fxLayout="row" fxLayoutAlign="center center">
                                            <button mat-raised-button type="submit" color="accent" [disabled]="cardExists || cardNumber.length === 0 || submitted">
                                                {{'Add'|translate}}
                                            </button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>


                        <div class="info-line">
                            <div class="title">{{'Phone'|translate}}</div>
                            <div class="info">
                                {{ user.phone }}
                            </div>
                        </div>
                        <div class="info-line">
                            <div class="title">{{'E-mail'|translate}}</div>
                            <div class="info">
                                {{ user.email }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.birthday && user.birthday.length>0">
                            <div class="title">{{'Birthday'|translate}}</div>
                            <div class="info">
                                {{ user.birthday }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.sex && user.sex.length>0">
                            <div class="title">{{'Sex'|translate}}</div>
                            <div class="info">
                                {{ user.sex }}
                            </div>
                        </div>

                        <div class="info-line">
                            <div class="title">{{'Created at'|translate}}</div>
                            <div class="info">
                                {{ user.createdAt|date: 'd.MM.y H:mm':'UTC': 'pl' }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user.description && user.description.length>0">
                            <div class="title">{{'Description'|translate}}</div>
                            <div class="info">
                                {{ user.description }}
                            </div>
                        </div>

                        <div class="info-line" *ngIf="user && user.documents">
                            <div class="title">Pliki</div>
                            <table class="table table-hover" style="width: 100%;">
                                <thead>
                                <tr>
                                    <th>Nazwa pliku</th>
                                    <th>Rozmiar</th>
                                    <th>Data dodania</th>
                                    <th>Dodał</th>
                                    <th>Akcje</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let document of user.documents">
                                    <td>{{document.originalName}}</td>
                                    <td style="text-align: right;">{{(document.size/(1024))| number:'1.0-0'}} kb</td>
                                    <td>{{document.createdAt|date: 'd.MM.y H:mm:ss': 'UTC+2': 'pl'}}</td>
                                    <td>{{document.createdBy?.firstName}} {{document.createdBy?.lastName}} ({{document.createdBy?.username}})</td>
                                    <td>
                                        <a *ngIf="!document.downloading" style="cursor: pointer;" (click)="downloadFile(document)">Pobierz</a>
                                        <span *ngIf="document.downloading">
                                <mat-spinner [diameter]="20"></mat-spinner> Pobieram...
                            </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <work-time [user]="user"></work-time>

                    </div>

                </div>
            </div>

            <!-- TRAINING HISTORY -->
            <div class="about-content p-24" fxLayout="column" fxFlex="100" fxFlex.gt-sm="100" fxFlex.gt-md="100">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent">
                        <div class="title">{{'Training History'|translate}}</div>
                    </header>

                    <div class="content">
                        <div *ngIf="trainingsLoading" class="spinner-container" fxLayout="row" fxLayoutAlign="center center">
                            <mat-spinner [diameter]="40"></mat-spinner>
                        </div>

                        <div *ngIf="!trainingsLoading && trainings.length === 0" class="empty-state p-24" fxLayout="row" fxLayoutAlign="center center">
                            <span>{{'No training sessions found'|translate}}</span>
                        </div>

                        <div *ngIf="!trainingsLoading && trainings.length > 0">
                            <table class="table table-hover" style="width: 100%;">
                                <thead>
                                <tr>
                                    <th>{{'Date'|translate}}</th>
                                    <th>{{'Device'|translate}}</th>
                                    <th style="text-align: center;">{{'Distance'|translate}} (km)</th>
                                    <th style="text-align: center;">{{'Calories'|translate}}</th>
                                    <th>{{'Status'|translate}}</th>
                                    <th>{{'Actions'|translate}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let training of trainings" style="cursor: pointer;">
                                    <td>{{training.createdAt | date: 'd.MM.y H:mm':'UTC': 'pl'}}</td>
                                    <td>{{training.resource?.name || training.deviceType || '-'}}</td>
                                    <td style="text-align: center">{{training.metrics?.distance ? (training.metrics.distance / 100000 | number:'1.1-2') : '-'}}</td>
                                    <td style="text-align: center;">{{training.metrics?.calories ? (training.metrics.calories | number:'1.0-0') : '-'}}</td>
                                    <td>
                                        <span *ngIf="training.isActive" style="color: green;">{{'Active'|translate}}</span>
                                        <span *ngIf="!training.isActive" style="color: gray;">{{'Finished'|translate}}</span>
                                    </td>
                                    <td>
                                        <button mat-icon-button [routerLink]="['/training-details', training.id]" matTooltip="{{'View Details'|translate}}">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            <!-- / TRAINING HISTORY -->

            <div class="about-content pl-24 pt-12 pr-24" fxLayout="column" fxFlex="80" fxFlex.gt-sm="80" fxFlex.gt-md="80" *ngFor="let note of notes">
                <div class="profile-box info-box general" fxLayout="column">
                    <header class="accent">
                        <div class="title">{{note.title}}</div>
                    </header>

                    <div class="content">
                        <div class="info-line">
                            <div class="info-line">
                                <div class="title">{{'Description'|translate}}</div>
                                <div class="info">{{note.description}}</div>
                            </div>

                            <div class="title">{{'Created'|translate}}</div>
                            <div class="info">
                                {{note.createdAt|date: 'd.MM.y H:mm':'UTC': 'pl'}}
                                {{'by'|translate}} {{note.createdBy.firstName}} {{note.createdBy.lastName}} ({{note.createdBy.username}})
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>
